/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
export type ItemProductSearchFilterPropertyFilterComputed_EntitySearchPropertyFilterBoolFilterComputed_Fragment = { __typename: 'EntitySearchPropertyFilterBoolFilterComputed', key: string, expr: string, valueBoolComputed?: boolean | null, missingValue: boolean, operatorBool: Types.EntitySearchBoolFilterOperator };

export type ItemProductSearchFilterPropertyFilterComputed_EntitySearchPropertyFilterBoolInFilterComputed_Fragment = { __typename: 'EntitySearchPropertyFilterBoolInFilterComputed', key: string, expr: string, valueBoolInComputed?: Array<boolean> | null, missingValue: boolean, operatorBoolIn: Types.EntitySearchBoolInFilterOperator };

export type ItemProductSearchFilterPropertyFilterComputed_EntitySearchPropertyFilterNumberBetweenFilterComputed_Fragment = { __typename: 'EntitySearchPropertyFilterNumberBetweenFilterComputed', key: string, expr: string, missingValue: boolean, operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetweenComputed?: { __typename: 'ValueNumberBetween', min: number, max: number } | null };

export type ItemProductSearchFilterPropertyFilterComputed_EntitySearchPropertyFilterNumberFilterComputed_Fragment = { __typename: 'EntitySearchPropertyFilterNumberFilterComputed', key: string, expr: string, valueNumberComputed?: number | null, missingValue: boolean, operatorNumber: Types.EntitySearchNumberFilterOperator };

export type ItemProductSearchFilterPropertyFilterComputed_EntitySearchPropertyFilterNumberInFilterComputed_Fragment = { __typename: 'EntitySearchPropertyFilterNumberInFilterComputed', key: string, expr: string, valueNumberInComputed?: Array<number> | null, missingValue: boolean, operatorNumberIn: Types.EntitySearchNumberInFilterOperator };

export type ItemProductSearchFilterPropertyFilterComputed_EntitySearchPropertyFilterTextFilterComputed_Fragment = { __typename: 'EntitySearchPropertyFilterTextFilterComputed', key: string, expr: string, valueTextComputed?: string | null, missingValue: boolean, operatorText: Types.EntitySearchTextFilterOperator };

export type ItemProductSearchFilterPropertyFilterComputed_EntitySearchPropertyFilterTextInFilterComputed_Fragment = { __typename: 'EntitySearchPropertyFilterTextInFilterComputed', key: string, expr: string, valueTextInComputed?: Array<string> | null, missingValue: boolean, operatorTextIn: Types.EntitySearchTextInFilterOperator };

export type ItemProductSearchFilterPropertyFilterComputedFragment = ItemProductSearchFilterPropertyFilterComputed_EntitySearchPropertyFilterBoolFilterComputed_Fragment | ItemProductSearchFilterPropertyFilterComputed_EntitySearchPropertyFilterBoolInFilterComputed_Fragment | ItemProductSearchFilterPropertyFilterComputed_EntitySearchPropertyFilterNumberBetweenFilterComputed_Fragment | ItemProductSearchFilterPropertyFilterComputed_EntitySearchPropertyFilterNumberFilterComputed_Fragment | ItemProductSearchFilterPropertyFilterComputed_EntitySearchPropertyFilterNumberInFilterComputed_Fragment | ItemProductSearchFilterPropertyFilterComputed_EntitySearchPropertyFilterTextFilterComputed_Fragment | ItemProductSearchFilterPropertyFilterComputed_EntitySearchPropertyFilterTextInFilterComputed_Fragment;

export type ItemProductSearchFilterPriceFilterComputed_EntitySearchNumberBetweenFilterComputed_Fragment = { __typename: 'EntitySearchNumberBetweenFilterComputed', expr: string, missingValue: boolean, operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetweenComputed?: { __typename: 'ValueNumberBetween', min: number, max: number } | null };

export type ItemProductSearchFilterPriceFilterComputed_EntitySearchNumberFilterComputed_Fragment = { __typename: 'EntitySearchNumberFilterComputed', expr: string, valueNumberComputed?: number | null, missingValue: boolean, operatorNumber: Types.EntitySearchNumberFilterOperator };

export type ItemProductSearchFilterPriceFilterComputedFragment = ItemProductSearchFilterPriceFilterComputed_EntitySearchNumberBetweenFilterComputed_Fragment | ItemProductSearchFilterPriceFilterComputed_EntitySearchNumberFilterComputed_Fragment;

export type ItemProductSearchFilterBrandFilterComputed_EntitySearchTextFilterComputed_Fragment = { __typename: 'EntitySearchTextFilterComputed', valueTextComputed?: string | null, operatorText: Types.EntitySearchTextFilterOperator, expr: string, missingValue: boolean };

export type ItemProductSearchFilterBrandFilterComputed_EntitySearchTextInFilterComputed_Fragment = { __typename: 'EntitySearchTextInFilterComputed', valueTextInComputed?: Array<string> | null, operatorTextIn: Types.EntitySearchTextInFilterOperator, expr: string, missingValue: boolean };

export type ItemProductSearchFilterBrandFilterComputedFragment = ItemProductSearchFilterBrandFilterComputed_EntitySearchTextFilterComputed_Fragment | ItemProductSearchFilterBrandFilterComputed_EntitySearchTextInFilterComputed_Fragment;

export type ItemProductSearchFilterBrandLineFilterComputed_EntitySearchTextFilterComputed_Fragment = { __typename: 'EntitySearchTextFilterComputed', valueTextComputed?: string | null, operatorText: Types.EntitySearchTextFilterOperator, expr: string, missingValue: boolean };

export type ItemProductSearchFilterBrandLineFilterComputed_EntitySearchTextInFilterComputed_Fragment = { __typename: 'EntitySearchTextInFilterComputed', valueTextInComputed?: Array<string> | null, operatorTextIn: Types.EntitySearchTextInFilterOperator, expr: string, missingValue: boolean };

export type ItemProductSearchFilterBrandLineFilterComputedFragment = ItemProductSearchFilterBrandLineFilterComputed_EntitySearchTextFilterComputed_Fragment | ItemProductSearchFilterBrandLineFilterComputed_EntitySearchTextInFilterComputed_Fragment;

export type ItemProductSearchFilterPropertyFilter_EntitySearchPropertyFilterBoolFilter_Fragment = { __typename: 'EntitySearchPropertyFilterBoolFilter', key: string, operatorBool: Types.EntitySearchBoolFilterOperator, valueBool: boolean };

export type ItemProductSearchFilterPropertyFilter_EntitySearchPropertyFilterBoolInFilter_Fragment = { __typename: 'EntitySearchPropertyFilterBoolInFilter', key: string, operatorBoolIn: Types.EntitySearchBoolInFilterOperator, valueBoolIn: Array<boolean> };

export type ItemProductSearchFilterPropertyFilter_EntitySearchPropertyFilterNumberBetweenFilter_Fragment = { __typename: 'EntitySearchPropertyFilterNumberBetweenFilter', key: string, operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetween: { __typename: 'ValueNumberBetween', min: number, max: number } };

export type ItemProductSearchFilterPropertyFilter_EntitySearchPropertyFilterNumberFilter_Fragment = { __typename: 'EntitySearchPropertyFilterNumberFilter', key: string, operatorNumber: Types.EntitySearchNumberFilterOperator, valueNumber: number };

export type ItemProductSearchFilterPropertyFilter_EntitySearchPropertyFilterNumberInFilter_Fragment = { __typename: 'EntitySearchPropertyFilterNumberInFilter', key: string, operatorNumberIn: Types.EntitySearchNumberInFilterOperator, valueNumberIn: Array<number> };

export type ItemProductSearchFilterPropertyFilter_EntitySearchPropertyFilterTextFilter_Fragment = { __typename: 'EntitySearchPropertyFilterTextFilter', key: string, operatorText: Types.EntitySearchTextFilterOperator, valueText: string };

export type ItemProductSearchFilterPropertyFilter_EntitySearchPropertyFilterTextInFilter_Fragment = { __typename: 'EntitySearchPropertyFilterTextInFilter', key: string, operatorTextIn: Types.EntitySearchTextInFilterOperator, valueTextIn: Array<string> };

export type ItemProductSearchFilterPropertyFilterFragment = ItemProductSearchFilterPropertyFilter_EntitySearchPropertyFilterBoolFilter_Fragment | ItemProductSearchFilterPropertyFilter_EntitySearchPropertyFilterBoolInFilter_Fragment | ItemProductSearchFilterPropertyFilter_EntitySearchPropertyFilterNumberBetweenFilter_Fragment | ItemProductSearchFilterPropertyFilter_EntitySearchPropertyFilterNumberFilter_Fragment | ItemProductSearchFilterPropertyFilter_EntitySearchPropertyFilterNumberInFilter_Fragment | ItemProductSearchFilterPropertyFilter_EntitySearchPropertyFilterTextFilter_Fragment | ItemProductSearchFilterPropertyFilter_EntitySearchPropertyFilterTextInFilter_Fragment;

export type ItemProductSearchFilterPriceFilter_EntitySearchNumberBetweenFilter_Fragment = { __typename: 'EntitySearchNumberBetweenFilter', operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetween: { __typename: 'ValueNumberBetween', min: number, max: number } };

export type ItemProductSearchFilterPriceFilter_EntitySearchNumberFilter_Fragment = { __typename: 'EntitySearchNumberFilter', operatorNumber: Types.EntitySearchNumberFilterOperator, valueNumber: number };

export type ItemProductSearchFilterPriceFilterFragment = ItemProductSearchFilterPriceFilter_EntitySearchNumberBetweenFilter_Fragment | ItemProductSearchFilterPriceFilter_EntitySearchNumberFilter_Fragment;

export type ItemProductSearchFilterIdFilter_EntitySearchIdFilter_Fragment = { __typename: 'EntitySearchIdFilter', valueId: string, operatorId: Types.EntitySearchIdFilterOperator };

export type ItemProductSearchFilterIdFilter_EntitySearchIdInFilter_Fragment = { __typename: 'EntitySearchIdInFilter', valueIdIn: Array<string>, operatorIdIn: Types.EntitySearchIdInFilterOperator };

export type ItemProductSearchFilterIdFilterFragment = ItemProductSearchFilterIdFilter_EntitySearchIdFilter_Fragment | ItemProductSearchFilterIdFilter_EntitySearchIdInFilter_Fragment;

export type ItemProductSearchIdFilterFragment = { __typename: 'EntitySearchIdFilter', valueId: string, operatorId: Types.EntitySearchIdFilterOperator };

export type ItemProductSearchFilterBrandFilter_EntitySearchTextFilter_Fragment = { __typename: 'EntitySearchTextFilter', valueText: string, operatorText: Types.EntitySearchTextFilterOperator };

export type ItemProductSearchFilterBrandFilter_EntitySearchTextInFilter_Fragment = { __typename: 'EntitySearchTextInFilter', valueTextIn: Array<string>, operatorTextIn: Types.EntitySearchTextInFilterOperator };

export type ItemProductSearchFilterBrandFilterFragment = ItemProductSearchFilterBrandFilter_EntitySearchTextFilter_Fragment | ItemProductSearchFilterBrandFilter_EntitySearchTextInFilter_Fragment;

export type ItemProductSearchFilterBrandLineFilter_EntitySearchTextFilter_Fragment = { __typename: 'EntitySearchTextFilter', valueText: string, operatorText: Types.EntitySearchTextFilterOperator };

export type ItemProductSearchFilterBrandLineFilter_EntitySearchTextInFilter_Fragment = { __typename: 'EntitySearchTextInFilter', valueTextIn: Array<string>, operatorTextIn: Types.EntitySearchTextInFilterOperator };

export type ItemProductSearchFilterBrandLineFilterFragment = ItemProductSearchFilterBrandLineFilter_EntitySearchTextFilter_Fragment | ItemProductSearchFilterBrandLineFilter_EntitySearchTextInFilter_Fragment;

export type ItemProductSearchFilterExpressionsFragment = { __typename: 'ItemProductSearchFilterExpressions', itemId: string, brandFilter?: { __typename: 'EntitySearchTextFilterComputed', valueTextComputed?: string | null, operatorText: Types.EntitySearchTextFilterOperator, expr: string, missingValue: boolean } | { __typename: 'EntitySearchTextInFilterComputed', valueTextInComputed?: Array<string> | null, operatorTextIn: Types.EntitySearchTextInFilterOperator, expr: string, missingValue: boolean } | null, brandLineFilter?: { __typename: 'EntitySearchTextFilterComputed', valueTextComputed?: string | null, operatorText: Types.EntitySearchTextFilterOperator, expr: string, missingValue: boolean } | { __typename: 'EntitySearchTextInFilterComputed', valueTextInComputed?: Array<string> | null, operatorTextIn: Types.EntitySearchTextInFilterOperator, expr: string, missingValue: boolean } | null, listPriceFilter?: { __typename: 'EntitySearchNumberBetweenFilterComputed', expr: string, missingValue: boolean, operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetweenComputed?: { __typename: 'ValueNumberBetween', min: number, max: number } | null } | { __typename: 'EntitySearchNumberFilterComputed', expr: string, valueNumberComputed?: number | null, missingValue: boolean, operatorNumber: Types.EntitySearchNumberFilterOperator } | null, propertyFilters: Array<{ __typename: 'EntitySearchPropertyFilterBoolFilterComputed', key: string, expr: string, valueBoolComputed?: boolean | null, missingValue: boolean, operatorBool: Types.EntitySearchBoolFilterOperator } | { __typename: 'EntitySearchPropertyFilterBoolInFilterComputed', key: string, expr: string, valueBoolInComputed?: Array<boolean> | null, missingValue: boolean, operatorBoolIn: Types.EntitySearchBoolInFilterOperator } | { __typename: 'EntitySearchPropertyFilterNumberBetweenFilterComputed', key: string, expr: string, missingValue: boolean, operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetweenComputed?: { __typename: 'ValueNumberBetween', min: number, max: number } | null } | { __typename: 'EntitySearchPropertyFilterNumberFilterComputed', key: string, expr: string, valueNumberComputed?: number | null, missingValue: boolean, operatorNumber: Types.EntitySearchNumberFilterOperator } | { __typename: 'EntitySearchPropertyFilterNumberInFilterComputed', key: string, expr: string, valueNumberInComputed?: Array<number> | null, missingValue: boolean, operatorNumberIn: Types.EntitySearchNumberInFilterOperator } | { __typename: 'EntitySearchPropertyFilterTextFilterComputed', key: string, expr: string, valueTextComputed?: string | null, missingValue: boolean, operatorText: Types.EntitySearchTextFilterOperator } | { __typename: 'EntitySearchPropertyFilterTextInFilterComputed', key: string, expr: string, valueTextInComputed?: Array<string> | null, missingValue: boolean, operatorTextIn: Types.EntitySearchTextInFilterOperator }> };

export type ItemProductSearchFilterDefinitionsFragment = { __typename: 'ItemProductSearchFilterDefinitions', itemId: string, favouritesFilter?: { __typename: 'EntitySearchBoolFilter', valueBool: boolean, operatorBool: Types.EntitySearchBoolFilterOperator } | null, productTypeIdFilter?: { __typename: 'EntitySearchIdFilter', valueId: string, operatorId: Types.EntitySearchIdFilterOperator } | null, supplierIdFilter?: { __typename: 'EntitySearchIdFilter', valueId: string, operatorId: Types.EntitySearchIdFilterOperator } | { __typename: 'EntitySearchIdInFilter', valueIdIn: Array<string>, operatorIdIn: Types.EntitySearchIdInFilterOperator } | null, brandFilter?: { __typename: 'EntitySearchTextFilter', valueText: string, operatorText: Types.EntitySearchTextFilterOperator } | { __typename: 'EntitySearchTextInFilter', valueTextIn: Array<string>, operatorTextIn: Types.EntitySearchTextInFilterOperator } | null, brandLineFilter?: { __typename: 'EntitySearchTextFilter', valueText: string, operatorText: Types.EntitySearchTextFilterOperator } | { __typename: 'EntitySearchTextInFilter', valueTextIn: Array<string>, operatorTextIn: Types.EntitySearchTextInFilterOperator } | null, listPriceFilter?: { __typename: 'EntitySearchNumberBetweenFilter', operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetween: { __typename: 'ValueNumberBetween', min: number, max: number } } | { __typename: 'EntitySearchNumberFilter', operatorNumber: Types.EntitySearchNumberFilterOperator, valueNumber: number } | null, netPriceFilter?: { __typename: 'EntitySearchNumberBetweenFilter', operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetween: { __typename: 'ValueNumberBetween', min: number, max: number } } | { __typename: 'EntitySearchNumberFilter', operatorNumber: Types.EntitySearchNumberFilterOperator, valueNumber: number } | null, propertyFilters: Array<{ __typename: 'EntitySearchPropertyFilterBoolFilter', key: string, operatorBool: Types.EntitySearchBoolFilterOperator, valueBool: boolean } | { __typename: 'EntitySearchPropertyFilterBoolInFilter', key: string, operatorBoolIn: Types.EntitySearchBoolInFilterOperator, valueBoolIn: Array<boolean> } | { __typename: 'EntitySearchPropertyFilterNumberBetweenFilter', key: string, operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetween: { __typename: 'ValueNumberBetween', min: number, max: number } } | { __typename: 'EntitySearchPropertyFilterNumberFilter', key: string, operatorNumber: Types.EntitySearchNumberFilterOperator, valueNumber: number } | { __typename: 'EntitySearchPropertyFilterNumberInFilter', key: string, operatorNumberIn: Types.EntitySearchNumberInFilterOperator, valueNumberIn: Array<number> } | { __typename: 'EntitySearchPropertyFilterTextFilter', key: string, operatorText: Types.EntitySearchTextFilterOperator, valueText: string } | { __typename: 'EntitySearchPropertyFilterTextInFilter', key: string, operatorTextIn: Types.EntitySearchTextInFilterOperator, valueTextIn: Array<string> }> };

export type ItemProductSearchFilterDefaultsFragment = { __typename: 'ItemProductSearchFilterDefaults', itemId: string, favouritesFilter?: { __typename: 'EntitySearchBoolFilter', valueBool: boolean, operatorBool: Types.EntitySearchBoolFilterOperator } | null, productTypeIdFilter?: { __typename: 'EntitySearchIdFilter', valueId: string, operatorId: Types.EntitySearchIdFilterOperator } | null, supplierIdFilter?: { __typename: 'EntitySearchIdFilter', valueId: string, operatorId: Types.EntitySearchIdFilterOperator } | { __typename: 'EntitySearchIdInFilter', valueIdIn: Array<string>, operatorIdIn: Types.EntitySearchIdInFilterOperator } | null, brandFilter?: { __typename: 'EntitySearchTextFilter', valueText: string, operatorText: Types.EntitySearchTextFilterOperator } | { __typename: 'EntitySearchTextInFilter', valueTextIn: Array<string>, operatorTextIn: Types.EntitySearchTextInFilterOperator } | null, brandLineFilter?: { __typename: 'EntitySearchTextFilter', valueText: string, operatorText: Types.EntitySearchTextFilterOperator } | { __typename: 'EntitySearchTextInFilter', valueTextIn: Array<string>, operatorTextIn: Types.EntitySearchTextInFilterOperator } | null, listPriceFilter?: { __typename: 'EntitySearchNumberBetweenFilter', operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetween: { __typename: 'ValueNumberBetween', min: number, max: number } } | { __typename: 'EntitySearchNumberFilter', operatorNumber: Types.EntitySearchNumberFilterOperator, valueNumber: number } | null, netPriceFilter?: { __typename: 'EntitySearchNumberBetweenFilter', operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetween: { __typename: 'ValueNumberBetween', min: number, max: number } } | { __typename: 'EntitySearchNumberFilter', operatorNumber: Types.EntitySearchNumberFilterOperator, valueNumber: number } | null, propertyFilters: Array<{ __typename: 'EntitySearchPropertyFilterBoolFilter', key: string, operatorBool: Types.EntitySearchBoolFilterOperator, valueBool: boolean } | { __typename: 'EntitySearchPropertyFilterBoolInFilter', key: string, operatorBoolIn: Types.EntitySearchBoolInFilterOperator, valueBoolIn: Array<boolean> } | { __typename: 'EntitySearchPropertyFilterNumberBetweenFilter', key: string, operatorNumberBetween: Types.EntitySearchNumberBetweenFilterOperator, valueNumberBetween: { __typename: 'ValueNumberBetween', min: number, max: number } } | { __typename: 'EntitySearchPropertyFilterNumberFilter', key: string, operatorNumber: Types.EntitySearchNumberFilterOperator, valueNumber: number } | { __typename: 'EntitySearchPropertyFilterNumberInFilter', key: string, operatorNumberIn: Types.EntitySearchNumberInFilterOperator, valueNumberIn: Array<number> } | { __typename: 'EntitySearchPropertyFilterTextFilter', key: string, operatorText: Types.EntitySearchTextFilterOperator, valueText: string } | { __typename: 'EntitySearchPropertyFilterTextInFilter', key: string, operatorTextIn: Types.EntitySearchTextInFilterOperator, valueTextIn: Array<string> }> };

export const ItemProductSearchFilterBrandFilterComputedFragmentDoc = gql`
    fragment ItemProductSearchFilterBrandFilterComputed on ItemProductSearchFilterBrandFilterComputed {
  ... on EntitySearchTextFilterComputed {
    valueTextComputed
    operatorText
    expr
    missingValue
  }
  ... on EntitySearchTextInFilterComputed {
    valueTextInComputed
    operatorTextIn
    expr
    missingValue
  }
}
    `;
export const ItemProductSearchFilterBrandLineFilterComputedFragmentDoc = gql`
    fragment ItemProductSearchFilterBrandLineFilterComputed on ItemProductSearchFilterBrandLineFilterComputed {
  ... on EntitySearchTextFilterComputed {
    valueTextComputed
    operatorText
    expr
    missingValue
  }
  ... on EntitySearchTextInFilterComputed {
    valueTextInComputed
    operatorTextIn
    expr
    missingValue
  }
}
    `;
export const ItemProductSearchFilterPriceFilterComputedFragmentDoc = gql`
    fragment ItemProductSearchFilterPriceFilterComputed on ItemProductSearchFilterPriceFilterComputed {
  ... on EntitySearchNumberFilterComputed {
    expr
    valueNumberComputed
    missingValue
    operatorNumber
  }
  ... on EntitySearchNumberBetweenFilterComputed {
    expr
    valueNumberBetweenComputed {
      min
      max
    }
    missingValue
    operatorNumberBetween
  }
}
    `;
export const ItemProductSearchFilterPropertyFilterComputedFragmentDoc = gql`
    fragment ItemProductSearchFilterPropertyFilterComputed on ItemProductSearchFilterPropertyFilterComputed {
  ... on EntitySearchPropertyFilterNumberFilterComputed {
    key
    expr
    valueNumberComputed
    missingValue
    operatorNumber
  }
  ... on EntitySearchPropertyFilterNumberInFilterComputed {
    key
    expr
    valueNumberInComputed
    missingValue
    operatorNumberIn
  }
  ... on EntitySearchPropertyFilterNumberBetweenFilterComputed {
    key
    expr
    valueNumberBetweenComputed {
      min
      max
    }
    missingValue
    operatorNumberBetween
  }
  ... on EntitySearchPropertyFilterTextFilterComputed {
    key
    expr
    valueTextComputed
    missingValue
    operatorText
  }
  ... on EntitySearchPropertyFilterTextInFilterComputed {
    key
    expr
    valueTextInComputed
    missingValue
    operatorTextIn
  }
  ... on EntitySearchPropertyFilterBoolFilterComputed {
    key
    expr
    valueBoolComputed
    missingValue
    operatorBool
  }
  ... on EntitySearchPropertyFilterBoolInFilterComputed {
    key
    expr
    valueBoolInComputed
    missingValue
    operatorBoolIn
  }
}
    `;
export const ItemProductSearchFilterExpressionsFragmentDoc = gql`
    fragment ItemProductSearchFilterExpressions on ItemProductSearchFilterExpressions {
  itemId
  brandFilter {
    ...ItemProductSearchFilterBrandFilterComputed
  }
  brandLineFilter {
    ...ItemProductSearchFilterBrandLineFilterComputed
  }
  listPriceFilter {
    ...ItemProductSearchFilterPriceFilterComputed
  }
  propertyFilters {
    ...ItemProductSearchFilterPropertyFilterComputed
  }
}
    ${ItemProductSearchFilterBrandFilterComputedFragmentDoc}
${ItemProductSearchFilterBrandLineFilterComputedFragmentDoc}
${ItemProductSearchFilterPriceFilterComputedFragmentDoc}
${ItemProductSearchFilterPropertyFilterComputedFragmentDoc}`;
export const ItemProductSearchIdFilterFragmentDoc = gql`
    fragment ItemProductSearchIdFilter on EntitySearchIdFilter {
  valueId
  operatorId
}
    `;
export const ItemProductSearchFilterIdFilterFragmentDoc = gql`
    fragment ItemProductSearchFilterIdFilter on ItemProductSearchFilterIdFilter {
  ...ItemProductSearchIdFilter
  ... on EntitySearchIdInFilter {
    valueIdIn
    operatorIdIn
  }
}
    ${ItemProductSearchIdFilterFragmentDoc}`;
export const ItemProductSearchFilterBrandFilterFragmentDoc = gql`
    fragment ItemProductSearchFilterBrandFilter on ItemProductSearchFilterBrandFilter {
  ... on EntitySearchTextFilter {
    valueText
    operatorText
  }
  ... on EntitySearchTextInFilter {
    valueTextIn
    operatorTextIn
  }
}
    `;
export const ItemProductSearchFilterBrandLineFilterFragmentDoc = gql`
    fragment ItemProductSearchFilterBrandLineFilter on ItemProductSearchFilterBrandLineFilter {
  ... on EntitySearchTextFilter {
    valueText
    operatorText
  }
  ... on EntitySearchTextInFilter {
    valueTextIn
    operatorTextIn
  }
}
    `;
export const ItemProductSearchFilterPriceFilterFragmentDoc = gql`
    fragment ItemProductSearchFilterPriceFilter on ItemProductSearchFilterPriceFilter {
  ... on EntitySearchNumberFilter {
    operatorNumber
    valueNumber
  }
  ... on EntitySearchNumberBetweenFilter {
    operatorNumberBetween
    valueNumberBetween {
      min
      max
    }
  }
}
    `;
export const ItemProductSearchFilterPropertyFilterFragmentDoc = gql`
    fragment ItemProductSearchFilterPropertyFilter on ItemProductSearchFilterPropertyFilter {
  ... on EntitySearchPropertyFilterBoolFilter {
    key
    operatorBool
    valueBool
  }
  ... on EntitySearchPropertyFilterBoolInFilter {
    key
    operatorBoolIn
    valueBoolIn
  }
  ... on EntitySearchPropertyFilterNumberFilter {
    key
    operatorNumber
    valueNumber
  }
  ... on EntitySearchPropertyFilterNumberInFilter {
    key
    operatorNumberIn
    valueNumberIn
  }
  ... on EntitySearchPropertyFilterNumberBetweenFilter {
    key
    operatorNumberBetween
    valueNumberBetween {
      min
      max
    }
  }
  ... on EntitySearchPropertyFilterTextFilter {
    key
    operatorText
    valueText
  }
  ... on EntitySearchPropertyFilterTextInFilter {
    key
    operatorTextIn
    valueTextIn
  }
}
    `;
export const ItemProductSearchFilterDefinitionsFragmentDoc = gql`
    fragment ItemProductSearchFilterDefinitions on ItemProductSearchFilterDefinitions {
  itemId
  favouritesFilter {
    ... on EntitySearchBoolFilter {
      valueBool
      operatorBool
    }
  }
  productTypeIdFilter {
    ...ItemProductSearchIdFilter
  }
  supplierIdFilter {
    ...ItemProductSearchFilterIdFilter
  }
  brandFilter {
    ...ItemProductSearchFilterBrandFilter
  }
  brandLineFilter {
    ...ItemProductSearchFilterBrandLineFilter
  }
  listPriceFilter {
    ...ItemProductSearchFilterPriceFilter
  }
  netPriceFilter {
    ...ItemProductSearchFilterPriceFilter
  }
  propertyFilters {
    ...ItemProductSearchFilterPropertyFilter
  }
}
    ${ItemProductSearchIdFilterFragmentDoc}
${ItemProductSearchFilterIdFilterFragmentDoc}
${ItemProductSearchFilterBrandFilterFragmentDoc}
${ItemProductSearchFilterBrandLineFilterFragmentDoc}
${ItemProductSearchFilterPriceFilterFragmentDoc}
${ItemProductSearchFilterPropertyFilterFragmentDoc}`;
export const ItemProductSearchFilterDefaultsFragmentDoc = gql`
    fragment ItemProductSearchFilterDefaults on ItemProductSearchFilterDefaults {
  itemId
  favouritesFilter {
    ... on EntitySearchBoolFilter {
      valueBool
      operatorBool
    }
  }
  productTypeIdFilter {
    ...ItemProductSearchIdFilter
  }
  supplierIdFilter {
    ...ItemProductSearchFilterIdFilter
  }
  brandFilter {
    ...ItemProductSearchFilterBrandFilter
  }
  brandLineFilter {
    ...ItemProductSearchFilterBrandLineFilter
  }
  listPriceFilter {
    ...ItemProductSearchFilterPriceFilter
  }
  netPriceFilter {
    ...ItemProductSearchFilterPriceFilter
  }
  propertyFilters {
    ...ItemProductSearchFilterPropertyFilter
  }
}
    ${ItemProductSearchIdFilterFragmentDoc}
${ItemProductSearchFilterIdFilterFragmentDoc}
${ItemProductSearchFilterBrandFilterFragmentDoc}
${ItemProductSearchFilterBrandLineFilterFragmentDoc}
${ItemProductSearchFilterPriceFilterFragmentDoc}
${ItemProductSearchFilterPropertyFilterFragmentDoc}`;